import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import i18n from './i18n'
import DatePicker from 'vue2-datepicker'
// import moment from 'moment'
import VueIntlNumberformat from 'vue-intl-numberformat'

import 'vue2-datepicker/locale/ko'

import Iamport from '@/components/common/Iamport.vue'
// import IamportDev from '@/components/common/IamportDev.vue'
import Modal from '@/components/common/Modal.vue'
import Pagination from '@/components/common/Pagination.vue'
import Sidebar from '@/components/library/Sidebar.vue'

import { directive as onClickaway } from 'vue-clickaway'
import Spinner from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueCookies from 'vue-cookies'
import Meta from 'vue-meta'

Vue.use(DatePicker)

//Cookies
Vue.use(VueCookies)
Vue.$cookies.config(60 * 60)

//vue-meta
Vue.use(Meta, {
  attribute: 'data-vue-meta'
})

// Components
// Vue.component('IamportDev', IamportDev)
Vue.component('Iamport', Iamport)
Vue.component('Modal', Modal)
Vue.component('Pagination', Pagination)
Vue.component('Sidebar', Sidebar)
Vue.component('Spinner', Spinner)
Vue.directive('on-clickaway', onClickaway)
Vue.component('VueIntlNumberformat', VueIntlNumberformat)
Vue.filter('date', function (value) {
  if (!value) return ''

  // 날짜 객체 생성 전에 유효성 검사
  const dateObj = new Date(value)
  if (isNaN(dateObj.getTime())) {
    console.warn('유효하지 않은 날짜 값:', value)
    return ''
  }

  try {
    return new Intl.DateTimeFormat('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    })
      .format(dateObj)
      .replace(/\. /g, '.')
      .slice(0, -1)
  } catch (error) {
    console.error('날짜 형식 지정 오류:', error)
    return ''
  }
})

Vue.filter('timestamp', function (value) {
  if (!value) return ''

  // 날짜 객체 생성 전에 유효성 검사
  const dateObj = new Date(value)
  if (isNaN(dateObj.getTime())) {
    console.warn('유효하지 않은 타임스탬프 값:', value)
    return ''
  }

  try {
    const dateStr = new Intl.DateTimeFormat('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    })
      .format(dateObj)
      .replace(/\. /g, '.')
      .slice(0, -1)

    const timeStr = new Intl.DateTimeFormat('ko-KR', {
      hour: 'numeric',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    }).format(dateObj)

    return `${dateStr} (${timeStr})`
  } catch (error) {
    console.error('타임스탬프 형식 지정 오류:', error)
    return ''
  }
})

// DatePicker styles
import './assets/datepicker/index.scss'

// #### Auto component registration of Base components ####
const requireComponent = require.context(
  // The relative path of the components folder
  './components/base',
  // Whether or not to look in subfolders
  false,
  // The regular expression used to match base component filenames
  /Base[A-Z]\w+\.(vue|js)$/
)
requireComponent.keys().forEach((fileName) => {
  // Get component config
  const componentConfig = requireComponent(fileName)

  // Get PascalCase name of component
  const componentName = upperFirst(
    camelCase(
      // Gets the file name regardless of folder depth
      fileName
        .split('/')
        .pop()
        .replace(/\.\w+$/, '')
    )
  )

  Vue.use(VueAwesomeSwiper)

  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  )
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
